<ejs-sidebar id="stages-menu" #sidebarInstance type='Over' [width]='width' [position]='position'
             style="visibility: hidden" [enableGestures]="false" [showBackdrop]=true>

  <div class="offcanvas-close mt-n1 pr-5" style="float:right; padding: 48px;">
    <a href="javascript:;" class="btn btn-xs btn-icon btn-light btn-hover-primary" id="kt_quick_panel_close"
       (click)="closeSidebar()">
      <i class="ki ki-close icon-xs text-muted"></i>
    </a>
  </div>

  <div class='p-15'>
    <h2 *ngIf="!articleStageInput">Add Article Stage Date</h2>
    <h2 *ngIf="articleStageInput">Update Article Stage Date</h2>

    <form id="formId" [formGroup]="articleStagesForm" #formDir="ngForm" class="form-horizontal" novalidate=""
          style="margin-top: 16px;">

      <div class="form-group sf-outline-input mb-10" [class.hide-label]="articleStagesForm.controls.article_stage_parent_code.value == ''">
        <ejs-dropdowntree formControlName="article_stage_parent_code" id='article_stage_parent_code' allowMultiSelection='false'
                          [fields]='articleStagesFields' placeholder='Parent Article Stage' floatLabelType="Auto" cssClass="e-filled"
                          (blur)="articleStagesForm.controls.article_stage_parent_code.markAsTouched()"></ejs-dropdowntree>
        <div>Note: If a parent status isn't selected, the new article stage will be added as a parent</div>
      </div>

      <div class="form-group sf-outline-input mb-10">
        <ejs-textbox id="Article Stage_name" placeholder="Article Stage Name *" cssClass="e-filled"
                     formControlName="article_stage_name" floatLabelType="Auto"
                     (blur)="articleStagesForm.controls.article_stage_name.markAsTouched()"
        ></ejs-textbox>
        <div *ngIf="articleStagesForm.controls.article_stage_name.errors">
          <div
            *ngIf="articleStagesForm.controls.article_stage_name.errors.required && articleStagesForm.controls.article_stage_name.touched"
            class="e-error">
            Article Stage Name is required.
          </div>
          <div
            *ngIf="articleStagesForm.controls.article_stage_name.errors.maxlength && articleStagesForm.controls.article_stage_name.touched"
            class="e-error">
            Article Stage Name cannot be more than 100 characters
          </div>
        </div>
      </div>

      <div class="form-group sf-outline-input mb-10">
        <label>Filter Color</label>
        <input ejs-colorpicker id="inline-color-picker" type="color" [modeSwitcher]=false  [showButtons]=false
               formControlName="filter_color" placeholder="Filter Color" cssClass="e-filled"  />
        <div *ngIf="articleStagesForm.controls.filter_color.errors">
          <div
            *ngIf="articleStagesForm.controls.filter_color.errors.required && articleStagesForm.controls.filter_color.touched"
            class="e-error">
            Filter color is required.
          </div>
        </div>
      </div>

      <div class="form-group sf-outline-input mb-10">
        <label>Filter Text Color</label>
        <input ejs-colorpicker id="inline-color-picker-text" type="color" [modeSwitcher]=false  [showButtons]=false
               formControlName="filter_text_color" placeholder="Filter Color" cssClass="e-filled"  />
        <div *ngIf="articleStagesForm.controls.filter_text_color.errors">
          <div
            *ngIf="articleStagesForm.controls.filter_text_color.errors.required && articleStagesForm.controls.filter_text_color.touched"
            class="e-error">
            Filter text color is required.
          </div>
        </div>
      </div>


      <div class="form-group sf-outline-input mb-10">
        <ejs-textbox id="short_code" placeholder="Short Code *" cssClass="e-filled"
                     formControlName="short_code" floatLabelType="Auto"
                     (blur)="articleStagesForm.controls.short_code.markAsTouched()"
        ></ejs-textbox>
        <div *ngIf="articleStagesForm.controls.short_code.errors">
          <div
            *ngIf="articleStagesForm.controls.short_code.errors.required && articleStagesForm.controls.short_code.touched"
            class="e-error">
            Short Code is required.
          </div>
          <div *ngIf="articleStagesForm.controls.short_code.errors.maxlength && articleStagesForm.controls.short_code.touched"
               class="e-error">
            Short Code cannot be more than 6 characters
          </div>
        </div>
      </div>

      <div class="form-group sf-outline-input mb-10">

        <ejs-numerictextbox id="rank_order" #rankOrder
                  formControlName="rank_order" floatLabelType="Auto" strictMode="true" validateDecimalOnType="true" 
                  cssClass="e-filled" placeholder="Rank" format='n0' min="1" [max]="maxValue" 
                ></ejs-numerictextbox>
                <div *ngIf="articleStagesForm.controls.rank_order.errors">
                  <div
                    *ngIf="articleStagesForm.controls.rank_order.errors.required && articleStagesForm.controls.rank_order.touched"
                    class="e-error">
                    Rank is required.
                  </div>
                </div>
      </div>

      <div class="form-group sf-outline-input mb-10">
        <ejs-textbox id="description" [multiline]="true" placeholder="Description" cssClass="e-filled"
                     formControlName="description" floatLabelType="Auto"
                     (blur)="articleStagesForm.controls.description.markAsTouched()"
        ></ejs-textbox>
        <div *ngIf="articleStagesForm.controls.description.errors">
          <div *ngIf="articleStagesForm.controls.description.errors.maxlength && articleStagesForm.controls.description.touched"
               class="e-error">
            Descripton cannot be more than 200 characters
          </div>
        </div>
      </div>


      <div *ngIf="articleStagesForm.invalid" class="e-error">Please fill all fields</div>
      <div *ngIf="error$ | async as error" class="e-error">{{error.error.message}}</div>

      <div class="my-10 pb-20">
        <button id="resetbtn"
                class="btn btn-outline-secondary text-uppercase font-weight-bold px-15 py-5 float-right btn-block mb-5"
                type="button"
                data-ripple="true" (click)="clear()">Clear
        </button>
        <button *ngIf="!articleStageInput" id="addSubmit"
                class="btn btn-primary text-uppercase font-weight-bold px-15 py-5 float-right btn-block" type="submit"
                (click)="onAddUpdateArticleStage(articleStagesForm); articleStagesForm.markAllAsTouched()" [disabled]="formSent" data-ripple="true"> Add
          Article Stage
        </button>
        <button *ngIf="articleStageInput" id="updateSubmit"
                class="btn btn-primary text-uppercase font-weight-bold px-15 py-5 float-right btn-block" type="submit"
                (click)="onAddUpdateArticleStage(articleStagesForm, true)" [disabled]="formSent" data-ripple="true">
          Update Article Stage
        </button>
      </div>
    </form>
  </div>
</ejs-sidebar>

<ejs-dialog #clearModal [buttons]='dltButtons' header='Are you sure?' animationSettings='none' showCloseIcon='true'
            width='25%' [visible]='false'>
  <ng-template #content>
    <p>This action will clear all form fields.</p>
  </ng-template>
</ejs-dialog>
